module.exports = __webpack_public_path__ + "static/img/siso.eb635cb5.png";